import { connect } from 'react-redux';
import { IQuickLookHOCProps } from './types';
import { IQuickLookEvents, IQuickLookFields } from '../../components/QuickLook/types';
import { QuickLook } from '../../components/QuickLook/QuickLook';
import { IApplicationState } from '../../../../../../../../types/types';
import { getQuickLookComponent } from './selectors/getQuickLookComponent';
import { onToggleQuickLookCollapse } from './events/onToggleQuickLookCollapse';
import { getCard } from '../../../../../../../../store/model/selectors/getCard';
import { setNeedCollapse } from './events/setNeedCollapse';

const mapStateToProps = (
    state: IApplicationState,
    { cardId, isClone, subcards, checklists, openedQuickLook, onHeightChange, onToggleLoadingImg }: IQuickLookHOCProps
): IQuickLookFields => {
    const { isQuickLookCollapse, isQuickLookNeedCollapse } = getCard(state, cardId);
    return {
        cardId,
        component: getQuickLookComponent(state, openedQuickLook, cardId, checklists, subcards, isClone, onHeightChange, onToggleLoadingImg),
        isCollapse: isQuickLookCollapse,
        isNeedCollapse: isQuickLookNeedCollapse,
        openedQuickLook,
    };
};

const mapDispatchToProps = (
    dispatch: any,
    { cardId }: IQuickLookHOCProps,
): IQuickLookEvents => {
    return {
        onToggleQuickLookCollapse: () => dispatch(onToggleQuickLookCollapse(cardId)),
        setNeedCollapse: (value) => dispatch(setNeedCollapse(cardId, value)),
    }
};

export const QuickLookHOC = connect(
    mapStateToProps,
    mapDispatchToProps
)(QuickLook);

QuickLookHOC.displayName = 'QuickLookHOC';
